module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_arrow3-852f2c9cae4ac758eecc6dfabb823a44.svg";